import axios from 'axios';
import { Env } from '@/configuration';
import { CommentView, CommentAdd, CommentEdit } from './models';

const fetchComments = async (contentObjectId: number | null) => {
  const apiUrl = contentObjectId ?
    Env.CoreApiOptions.endpointUrl(`comments/contentObjectId/${contentObjectId}`) :
    Env.CoreApiOptions.endpointUrl(`comments`);
  const response = await axios.get(apiUrl);
  const result: CommentView[] = response && response.data;

  return result;
};

const addComment = async (newComment: CommentAdd) => {
  const endpointUrl = Env.CoreApiOptions.endpointUrl(`comments`);
  const response = await axios.post(endpointUrl, newComment);
  const result: any = response && response.data;

  return result;
};

const editComment = async (comment: CommentEdit) => {
  const endpointUrl = Env.CoreApiOptions.endpointUrl(`comments`);
  const response = await axios.put(endpointUrl, comment);
  const result: any = response && response.data;

  return result;
};

const deleteComment = async (id: number) => {
  const deleteCommentUrl = Env.CoreApiOptions.endpointUrl(`comments/${id}`);

  const response = await axios.delete(deleteCommentUrl);
  const result: any = response && response.data;

  return result;
};

export default {
  fetchComments,
  addComment,
  editComment,
  deleteComment,
};
